enum YesNoUnknown {
  NotSet = 0,
  Yes = 1,
  No = 2,
  Unknown = 3
}

export default YesNoUnknown;
